import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import books from "../../Assets/data/books.json";
import articles from "../../Assets/data/journalarticles.json";
const PublicationsSection = () => {
  const navigate = useNavigate();
  return (
    <Box
      style={{
        background: "#003366",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "2em",
        paddingBottom: "2em",
      }}
    >
      <Box style={{ maxWidth: "960px", width: "100%" }}>
        <Typography
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginBottom: "24px",
          }}
          fontSize="24px"
          color="white"
        >
          PUBLICATIONS
        </Typography>
        <Grid container columnGap={4} wrap="nowrap">
          <Grid item xs={4} style={{ overflow: "hidden" }}>
            <img
              src={process.env.PUBLIC_URL + "Images/publication.jpg"}
              alt="Publish"
              style={{
                width: "-webkit-fill-available",
              }}
            />
          </Grid>
          <Grid
            item
            xs={3}
            style={{
              background: "white",
              padding: "16px",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                cursor: "pointer",
              }}
              onClick={() => navigate("/publications")}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                fontWeight={600}
                fontSize="18px"
              >
                Featured Paper
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                fontWeight={600}
                fontSize="18px"
              >
                {articles[0].title.slice(0, 50) + "..."}
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                fontWeight={500}
                fontStyle="italic"
                fontSize="16px"
              >
                {articles[0].authors.slice(0, 50) + "..."}
              </Typography>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                fontWeight={400}
                fontSize="14px"
              >
                {"Year " + articles[0].year}
              </Typography>
              {/* <div>
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={400}
                  fontSize="14px"
                >
                  Vol IX
                </Typography>
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={400}
                  fontSize="14px"
                >
                  Page XV
                </Typography>
              </div> */}
            </div>
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              background: "white",
              padding: "16px",
              boxSizing: "border-box",
            }}
          >
            <Box
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={600}
                  fontSize="18px"
                >
                  Books
                </Typography>
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={600}
                  fontSize="24px"
                >
                  {books.length}
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={600}
                  fontSize="18px"
                >
                  Journal Articles
                </Typography>
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fontWeight={600}
                  fontSize="24px"
                >
                  {articles.length}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PublicationsSection;
